<div class="timeline-container" #timeline>
    <div class="tree">
        <div class="separator-label">{{'attachments'}}</div>
        <ng-container *ngFor="let line of filteredAttachmentLines">
            <div class="line-info" *ngIf="!singleTimeline && !line.hidden">
                {{line.name}} ({{line.positions.length}})
            </div>

            <div class="line-info" *ngIf="!line.hidden && singleTimeline"
                [style.backgroundColor]="line.backgroundColor">
                <div class="line-name" *ngIf="line.isParent" (click)="onLineClick('attachment', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="line-name child-line" *ngIf="!line.isParent" (click)="onLineClick('attachment', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="arrows attachment-arrows" *ngIf="line.hasChildren">
                    <div class="arrow-down" *ngIf="line.open" (click)="closeLine('attachment', line)"></div>
                    <div class="arrow-left" *ngIf="!line.open" (click)="openLine('attachment', line)"></div>
                </div>
            </div>
        </ng-container>

        <div class="separator-label">
            {{'events'}}
        </div>

        <ng-container *ngFor="let line of filteredEventLines">
            <div class="line-info" *ngIf="!line.hidden" [style.backgroundColor]="line.backgroundColor">
                <div class="line-name" *ngIf="line.isParent" [ngClass]="{'middle-line': line.hasParent }"
                    (click)="onLineClick('event', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="line-name child-line" *ngIf="!line.isParent" (click)="onLineClick('event', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="arrows" *ngIf="line.hasChildren">
                    <div class="arrow-down" *ngIf="line.open" (click)="closeLine('event', line)"></div>

                    <div class="arrow-left" *ngIf="!line.open" (click)="openLine('event', line)"></div>
                </div>
            </div>
        </ng-container>

        <div class="separator-label">
            {{'metrics'}}
        </div>

        <ng-container *ngFor="let line of filteredLines">
            <div class="line-info" *ngIf="!line.hidden" [style.backgroundColor]="line.backgroundColor">
                <div class="line-name" *ngIf="line.isParent" [ngClass]="{'middle-line': line.hasParent }"
                    (click)="onLineClick('metric', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="line-name child-line" *ngIf="!line.isParent" (click)="onLineClick('metric', line)">
                    {{line.name}}
                    ({{line.positions.length}})
                </div>

                <div class="arrows" *ngIf="line.hasChildren">
                    <div class="arrow-down" *ngIf="line.open" (click)="closeLine('metric', line)"></div>
                    <div class="arrow-left" *ngIf="!line.open" (click)="openLine('metric', line)"></div>
                </div>
            </div>
        </ng-container>

        <div class="tree-bottom">
            <div class="group" *ngIf="overflowX != 'visible'">
                <lib-button (click)="setZoom(1)" icon="zoom_out" color="none" textColor="muted">
                </lib-button>

                <lib-button (click)="setZoom(-1)" icon="zoom_in" color="none" textColor="muted">
                </lib-button>

                <lib-button (click)="exportTimeline()" icon="download" color="none" textColor="secondary">
                </lib-button>
            </div>
        </div>
    </div>

    <div id="info-box" *ngIf="infoBox.visible" class="info-box" [style.left]="infoBox.left + 'px'"
        [style.top]="infoBox.top + 'px'" (mouseenter)="onMouseEnterInfo()" (mouseleave)="onMouseLeaveInfo()">
        <div class="info-box-container">
            <div *ngIf="!showRawData">
                <img *ngIf="infoBox.thumbnail" [src]="infoBox.thumbnail" (click)="onImgClick()">

                <div class="row space">
                    <div class="column">
                        <div *ngIf="infoBox.compactData.title && infoBox.compactData.metricName != 'Attachments'"
                            class="metric-title">
                            <strong>{{getDisplayName(infoBox.compactData.title)}}</strong>
                        </div>

                        <div *ngIf="infoBox.compactData.metricName == 'Attachments' && infoBox.compactData.crane"
                            class="metric-title">
                            <strong>{{ getDisplayName(infoBox.compactData.crane) }}</strong>
                        </div>

                        <div *ngIf="infoBox.compactData.metricName == 'Attachments' && !infoBox.compactData.crane && infoBox.compactData.concretings"
                            class="metric-title">
                            <strong>{{infoBox.compactData.concretings}}</strong>
                        </div>

                        <div *ngIf="infoBox.compactData.metricName" class="metric-name space-vertical">
                            {{getDisplayName(infoBox.compactData.metricName)}}
                        </div>
                    </div>

                    <div>
                        <lib-button (click)="openModification(infoBox)" color="none" textColor="primary" icon="settings"
                            *ngIf="infoBox.compactData.customMetric">
                        </lib-button>

                        <lib-button (click)="deleteMetric(infoBox)" color="none" textColor="danger" icon="delete"
                            *ngIf="infoBox.compactData.customMetric">
                        </lib-button>

                        <lib-button [matMenuTriggerFor]="menu" color="none" textColor="*primary" icon="more_horiz">
                        </lib-button>
                    </div>

                    <mat-menu #menu="matMenu">
                        <div class="menu-box">
                            <button mat-menu-item (click)="onReplayClick('project/dashboard')" class="primary">
                                <mat-icon fontIcon="dashboard"></mat-icon>
                                {{'dashboard.title' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/viewer/maps')" class="primary">
                                <mat-icon fontIcon="map"></mat-icon>
                                {{'viewer.maps' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/viewer/forge')" class="primary">
                                <mat-icon fontIcon="view_in_ar"></mat-icon>
                                {{'viewer.forge' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/plannings')" class="primary">
                                <mat-icon fontIcon="event_note"></mat-icon>
                                {{'planning.details' | translate}}
                            </button>

                            <button mat-menu-item (click)="onRawDataClick()" class="muted">
                                <mat-icon fontIcon="data_object"></mat-icon>
                                {{ showRawData ? ('viewer.raw_data_off' | translate) : ('viewer.raw_data' | translate)
                                }}
                            </button>
                        </div>
                    </mat-menu>
                </div>

                <hr>

                <!--Tracker / Unit-->
                <div class="row space-row">
                    <mat-icon
                        *ngIf="infoBox.compactData.tracker || infoBox.compactData.unit || infoBox.compactData.trackerName || infoBox.compactData.unitName"
                        class="center-icon space-icon">pin_drop</mat-icon>

                    <div class="column">
                        <div *ngIf="infoBox.compactData.unitName || infoBox.compactData.unit" class="metric-title">
                            <strong>{{infoBox.compactData.unitName || infoBox.compactData.unit}}</strong>
                        </div>

                        <div *ngIf="infoBox.compactData.trackerName || infoBox.compactData.tracker"
                            class="space-vertical">
                            {{infoBox.compactData.trackerName || infoBox.compactData.tracker}}
                        </div>
                    </div>
                </div>

                <!--User-->
                <div class="row space-row" *ngIf="infoBox.compactData.userEmail">
                    <mat-icon class="center-icon space-icon">person</mat-icon>

                    <div class="column">
                        <div class="metric-title">
                            <strong>{{infoBox.compactData.userEmail}}</strong>
                        </div>
                    </div>
                </div>

                <!--Date/time-->
                <div class="row space-row" *ngIf="infoBox.compactData.startDate">
                    <mat-icon class="center-icon space-icon">timer</mat-icon>

                    <div class="column">
                        <div *ngIf="infoBox.compactData.startDate">
                            <ng-container
                                *ngIf="infoBox.compactData.metricName == 'Attachments' || infoBox.compactData.metricName == 'device'">
                                {{ infoBox.compactData.startDate | date: 'HH:mm:ss' }}
                            </ng-container>

                            <ng-container
                                *ngIf="infoBox.compactData.startDate && infoBox.compactData.endDate && infoBox.compactData.metricName != 'Attachments' && infoBox.compactData.metricName != 'device'">
                                {{ infoBox.compactData.startDate | date: 'HH:mm:ss' }} - {{ infoBox.compactData.endDate
                                | date: 'HH:mm:ss' }}
                            </ng-container>

                            <ng-container
                                *ngIf="!infoBox.compactData.endDate && infoBox.compactData.metricName != 'Attachments' && infoBox.compactData.metricName != 'device'">
                                {{ infoBox.compactData.endDate | date: 'HH:mm:ss' }}
                            </ng-container>
                        </div>

                        <div *ngIf="infoBox.compactData.durationTime && infoBox.compactData.metricName != 'Attachments' && infoBox.compactData.metricName != 'device'"
                            class="space-vertical">
                            <strong>{{infoBox.compactData.durationTime}}</strong>
                        </div>
                    </div>
                </div>

                <!--Comment-->
                <div class="row space-row row-center" *ngIf="infoBox.compactData.comment">
                    <div class="center-icon">
                        <mat-icon>info</mat-icon>
                    </div>

                    <div class="center-text">
                        <span>{{infoBox.compactData.comment}}</span>
                    </div>
                </div>

                <!--Weight / Total-->
                <div class="row space-row">
                    <ng-container
                        *ngIf="infoBox.compactData.weightTotal || infoBox.compactData.weight || infoBox.compactData.totalWeight">
                        <mat-icon class="center-icon space-icon">fitness_center</mat-icon>

                        <div class="column">
                            <div *ngIf="(infoBox.compactData.weightTotal || infoBox.compactData.totalWeight)"
                                class="metric-title2 space-vertical">
                                <strong>{{ 'units.total_weight' | translate }}</strong>
                            </div>

                            <div *ngIf="infoBox.compactData.weight" class="metric-title2 space-vertical">
                                <strong>{{ 'units.weight' | translate }}</strong>
                            </div>

                            <div class="space-vertical">
                                {{ infoBox.compactData.weightTotal || infoBox.compactData.weight ||
                                infoBox.compactData.totalWeight }} kg
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="infoBox.compactData.distance">
                        <mat-icon class="center-icon space-icon">360</mat-icon>

                        <div class="column">
                            <div class="metric-title2 space-vertical">
                                <strong>Distance</strong>
                            </div>

                            <div class="space-vertical">
                                {{infoBox.compactData.distance | number:'1.2-2'}} m
                            </div>
                        </div>
                    </ng-container>
                </div>

                <!--ConcreteWeight / Volume-->
                <div class="row space-row" *ngIf="infoBox.compactData.concreteWeight || infoBox.compactData.volume">
                    <ng-container *ngIf="infoBox.compactData.concreteWeight">
                        <mat-icon class="center-icon space-icon">save_alt</mat-icon>

                        <div class="column">
                            <div class="metric-title2 space-vertical">
                                <strong>{{ 'units.concrete_weight' | translate }}</strong>
                            </div>

                            <div class="space-vertical">
                                {{infoBox.compactData.concreteWeight}} kg
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="infoBox.compactData.volume">
                        <mat-icon [ngClass]="infoBox.compactData.concreteWeight ? 'space-beton' : ''"
                            class="center-icon space-icon" fontIcon="water_drop">
                        </mat-icon>

                        <div class="column">
                            <div class="metric-title2 space-vertical">
                                <strong>Volume</strong>
                            </div>

                            <div class="space-vertical">
                                {{infoBox.compactData.volume}} m3
                            </div>
                        </div>
                    </ng-container>
                </div>

                <!--task-->
                <div class="row space-row" *ngIf="infoBox.compactData.task">
                    <mat-icon class="center-icon space-icon">calendar_today</mat-icon>
                    <div class="column">
                        <div class="metric-title2 space-vertical">
                            {{infoBox.compactData.planning}}
                        </div>

                        <div class="space-vertical">
                            <strong>{{infoBox.compactData.task}}</strong>
                        </div>
                    </div>
                </div>

                <!--Battery shackle/tracker-->
                <div class="row space-row" *ngIf="infoBox.compactData.trackerBattery">
                    <ng-container *ngIf="infoBox.compactData.trackerBattery">
                        <mat-icon class="center-icon space-icon"
                            [ngStyle]="{ 'color': getBatteryColor(infoBox.compactData.trackerBattery) }">
                            battery_full
                        </mat-icon>

                        <div class="column">
                            <div class="metric-title2 space-vertical">
                                <strong>{{"units.tracker" | translate}}</strong>
                            </div>

                            <div class="space-vertical">
                                {{infoBox.compactData.trackerBattery.toFixed(2)}} %
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="infoBox.compactData.shackleBattery !== undefined">
                        <mat-icon class="space-beton center-icon space-icon" svgIcon="shackle_full"
                            [ngStyle]="{ 'color': getShackleColor(infoBox.compactData.shackleBattery) }">
                        </mat-icon>

                        <div class="column space-add">
                            <div class="metric-title2 space-vertical">
                                <strong>Peson</strong>
                            </div>

                            <div class="space-vertical">
                                {{infoBox.compactData.shackleBattery.toFixed(2)}} %
                            </div>
                        </div>
                    </ng-container>
                </div>

            </div>

            <div *ngIf="showRawData">
                <img *ngIf="infoBox.thumbnail" [src]="infoBox.thumbnail" (click)="onImgClick()">

                <div class="row space">

                    <div class="column">
                        <div *ngIf="infoBox.compactData.title" class="metric-title">
                            <strong>{{infoBox.compactData.title}}</strong>
                        </div>

                        <div *ngIf="infoBox.compactData.metricName" class="metric-name space-vertical">
                            {{infoBox.compactData.metricName}}
                        </div>
                    </div>

                    <div>
                        <button mat-icon-button aria-label="Open modification" (click)="openModification(infoBox)"
                            class="button" color="secondary" *ngIf="infoBox.compactData.customMetric">
                            <mat-icon color="primary" class="icon">settings</mat-icon>
                        </button>

                        <button mat-icon-button aria-label="Delete metric" class="button"
                            (click)="deleteMetric(infoBox)" color="secondary" *ngIf="infoBox.compactData.customMetric">
                            <mat-icon color="warn" class="icon">delete</mat-icon>
                        </button>

                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Open journal dropdown menu"
                            class="button" color="secondary">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                    </div>

                    <mat-menu #menu="matMenu">
                        <div class="menu-box">
                            <button mat-menu-item (click)="onReplayClick('project/dashboard')" class="primary">
                                <mat-icon fontIcon="dashboard"></mat-icon>
                                {{'dashboard.title' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/viewer/maps')" class="primary">
                                <mat-icon fontIcon="map"></mat-icon>
                                {{'viewer.maps' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/viewer/forge')" class="primary">
                                <mat-icon fontIcon="view_in_ar"></mat-icon>
                                {{'viewer.forge' | translate}}
                            </button>

                            <button mat-menu-item (click)="onReplayClick('project/plannings')" class="primary">
                                <mat-icon fontIcon="event_note"></mat-icon>
                                {{'planning.details' | translate}}
                            </button>

                            <button mat-menu-item (click)="onRawDataClick()" class="muted">
                                <mat-icon fontIcon="data_object"></mat-icon>
                                {{ showRawData ? ('viewer.raw_data_off' | translate) : ('viewer.raw_data' | translate)
                                }}
                            </button>
                        </div>
                    </mat-menu>
                </div>

                <hr>

                <div class="raw-data">
                    <div *ngFor="let item of infoBox.data">
                        {{item.key}}: {{item.value}}
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="board" id="timeline-board" [style.overflowX]="overflowX" [style.overflowY]="overflowY" #scrollBar>
        <div class="graph-container" id="graph-container" [style.width]="hours.length * hourSize * scale + 'px'"
            (mousemove)="onMouseMove($event)">

            <div class="dark-bar" [style.left]="darkBarLeft + 'px'" *ngIf="darkBarVisible"></div>

            <div id="test" *ngFor="let _ of [].constructor(hours.length * 60); let i = index;"
                [style.left]="(hourSize * scale * i / 60)+ 'px'" class="vertical">
            </div>

            <div class="lines-container">
                <!-- ATTACHMENTS -->
                <div class="separator-label" (click)="toggle('attachments')">
                    {{'attachments'}}
                </div>

                <ng-container *ngFor="let line of filteredAttachmentLines; let lineIndex = index">
                    <div *ngIf="!line.hidden" class="line"
                        [class.last-line]="isLastVisibleLine(filteredAttachmentLines, lineIndex)"
                        [style.backgroundColor]="line.backgroundColor">
                        <div *ngFor="let position of line.positions; let posIndex = index" class="graph"
                            [style.left]="(position[0] * scale)+ 'px'"
                            (mouseenter)="onMouseEnterBar($event, line, posIndex)">
                            <div class="graph-bar" [style.width]="(position[1] * scale) + 'px'"
                                [style.background]="line.color" data-testid="timeline-attachment-bar">
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- EVENTS -->
                <div class="separator-label">{{'events'}}</div>

                <ng-container *ngFor="let line of filteredEventLines; let lineIndex = index">
                    <div *ngIf="!line.hidden" class="line"
                        [class.last-line]="isLastVisibleLine(filteredEventLines, lineIndex)"
                        [style.backgroundColor]="line.backgroundColor">
                        <div *ngFor="let position of line.positions; let posIndex = index" class="graph"
                            [style.left]="(position[0] * scale)+ 'px'" (mouseleave)="onMouseLeaveBar()"
                            (mouseenter)="onMouseEnterBar($event, line, posIndex)">
                            <div class="graph-bar" [style.width]="getScaled(position[1]) + 'px'"
                                [style.background]="line.color" data-testid="timeline-event-bar">
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- METRICS -->
                <div class="separator-label">
                    {{'metrics'}}
                </div>

                <ng-container *ngFor="let line of filteredLines; let lineIndex = index">
                    <div *ngIf="!line.hidden" class="line"
                        [class.last-line]="isLastVisibleLine(filteredLines, lineIndex)"
                        [style.backgroundColor]="line.backgroundColor">

                        <div *ngFor="let position of line.positions; let posIndex = index" class="graph"
                            [style.left]="getScaled(position[0])+ 'px'" (mouseleave)="onMouseLeaveBar()"
                            (mouseenter)="onMouseEnterBar($event, line, posIndex)"
                            [class.highlighted]="line.data[posIndex]?.id === highlightedMetricId"
                            [attr.data-metric-id]="line.data[posIndex]?.id">
                            <div class="graph-bar" [style.width]="getScaled(position[1]) + 'px'"
                                [style.background]="line.data[posIndex].color || line.color"
                                data-testid="timeline-metric-bar">
                                <div class="line-label">
                                    {{getDisplayName(line.data[posIndex].label)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="hour-container">
            <div *ngFor="let hour of hours" class="hour" [style.width]="getScaled(hourSize) + 'px'"
                [style.left]="(hour.position * scale) + 'px'">
                <div class="hour-label">
                    {{hour.label}}
                </div>
            </div>
        </div>
    </div>
</div>